import { render, staticRenderFns } from "./metarialItem.vue?vue&type=template&id=33d93f9d&scoped=true"
import script from "./metarialItem.vue?vue&type=script&lang=js"
export * from "./metarialItem.vue?vue&type=script&lang=js"
import style0 from "./metarialItem.vue?vue&type=style&index=0&id=33d93f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d93f9d",
  null
  
)

export default component.exports